import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Drawer as Component } from "./Drawer";
import { NOTEBOOK_SECTIONS as PROTOCOL_NOTEBOOK_SECTIONS } from "@learningblocks/protocol-constants/lib/Utilities";
import { NOTEBOOK_SECTIONS as EXP_NOTEBOOK_SECTIONS } from "@learningblocks/exp-constants/lib/Utilities";

function mapStateToProps(state) {
  return {
    visible: !state.notebook.notebookCollapsed,
    showOverlay: getShowOverlay(state),
    collapsed: state.notebook.notebookCollapsed,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Drawer = connect(mapStateToProps, mapDispatchToProps)(Component);

const getCurrentSection = ({ notebook }) => notebook.currentSection;

const getShowOverlay = createSelector([getCurrentSection], (currentSection) =>
  currentSection &&
  (
    currentSection.title === EXP_NOTEBOOK_SECTIONS.DESIGN ||
    currentSection.title === PROTOCOL_NOTEBOOK_SECTIONS.PROTOCOL
  )
    ? false
    : true
);
